export default __webpack_public_path__ + "89af29fa77ba50d0fdf4b39b420fd34d.svg";